import qs from 'query-string';
import { apiConfig } from '../api-config';

export interface UpdateStepRegisterParams {
  cdTerritory: string;
  currentStep: number;
  termId: number;
  isComplete?: boolean;
}

export const updateStepRegister = async (params: UpdateStepRegisterParams) => {
  const userLogged = JSON.parse(sessionStorage.getItem('userLogged') as string);

  const query = qs.stringify({
    ...params,
    cdUser: userLogged.idUser,
    tokenKey: userLogged.company.stKey,
  });

  return apiConfig
    .patch(`api/StepRegister/update?${query}`)
    .then((resp) => resp.data)
    .catch((err) => ({ hasErros: true, err }));
};
